import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../axios';

const initialState = {
	driverApprovalSettings: {
		loading: false,
		data: null,
		error: null,
	},
};

export const getDriverApprovalSettings = createAsyncThunk(
	'DriverApprovalSettings/getDriverApprovalSettings',
	async (_, { rejectWithValue }) => {
		try {
			const response = await axios.get('settings/driver-approval');
			return response.data;
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				error.response?.statusText ||
				error.message ||
				'Unknown error occurred';
			const statusCode = error.response?.status;
			return rejectWithValue({
				message: errorMessage,
				status: statusCode,
			});
		}
	},
);

export const updateDriverApprovalSettings = createAsyncThunk(
	'DriverApprovalSettings/updateDriverApprovalSettings',
	async (settingsData, { rejectWithValue }) => {
		try {
			const response = await axios.put('settings/driver-approval', settingsData);
			return response.data;
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				error.response?.statusText ||
				error.message ||
				'Unknown error occurred';
			const statusCode = error.response?.status;
			return rejectWithValue({
				message: errorMessage,
				status: statusCode,
			});
		}
	},
);

const driverApprovalSettingsSlice = createSlice({
	name: 'driverApprovalSettings',
	initialState,
	reducers: {
		resetDriverApprovalSettings: (state) => {
			state.driverApprovalSettings = initialState.driverApprovalSettings;
		},
	},
	extraReducers: (builder) => {
		builder
			// Get driver approval settings
			.addCase(getDriverApprovalSettings.pending, (state) => {
				state.driverApprovalSettings.loading = true;
				state.driverApprovalSettings.error = null;
			})
			.addCase(getDriverApprovalSettings.fulfilled, (state, action) => {
				state.driverApprovalSettings.loading = false;
				state.driverApprovalSettings.data = action.payload;
				state.driverApprovalSettings.error = null;
			})
			.addCase(getDriverApprovalSettings.rejected, (state, action) => {
				state.driverApprovalSettings.loading = false;
				state.driverApprovalSettings.error =
					action.payload?.message || action.error?.message || 'Unknown error';
			})
			// Update driver approval settings
			.addCase(updateDriverApprovalSettings.pending, (state) => {
				state.driverApprovalSettings.loading = true;
				state.driverApprovalSettings.error = null;
			})
			.addCase(updateDriverApprovalSettings.fulfilled, (state, action) => {
				state.driverApprovalSettings.loading = false;
				state.driverApprovalSettings.data = action.payload;
				state.driverApprovalSettings.error = null;
			})
			.addCase(updateDriverApprovalSettings.rejected, (state, action) => {
				state.driverApprovalSettings.loading = false;
				state.driverApprovalSettings.error =
					action.payload?.message || action.error?.message || 'Unknown error';
			});
	},
});

export default driverApprovalSettingsSlice.reducer;
export const { resetDriverApprovalSettings } = driverApprovalSettingsSlice.actions;
